// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "wdth" 100;
}

.sidebar {
  background-color: #c0c0c0;
  width: 280px;
}

.sidebar .title {
  font-weight: bold;
}

.sidebar .link {
  text-decoration: none;
}

header {
  background-color: #3D5AFE;
  color: white;
}

footer {
  background-color: #3D5AFE;
  color: white;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./vue/style.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;EAEA,iCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,qBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;AAAJ","sourcesContent":["html {\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n\n    font-family: \"Roboto\", sans-serif;\n    font-optical-sizing: auto;\n    font-weight: 400;\n    font-style: normal;\n    font-variation-settings: \"wdth\" 100;\n}\n\n.sidebar {\n    background-color: #c0c0c0;\n    width: 280px;\n}\n\n.sidebar .title {\n    font-weight: bold;\n}\n\n.sidebar .link {\n    text-decoration: none;\n}\n\nheader {\n    background-color: #3D5AFE;\n    color: white;\n}\n\nfooter {\n    background-color: #3D5AFE;\n    color: white;\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
